import { BASE_URL } from '../../../../../utils/config.base-url'

export const DOCUMENT_PREFIX_URL = '/document'
export const DOCUMENT_FOLDER_PREFIX_URL = '/folder-document'
export const DOCUMENT_LIST_PREFIX_URL = '/list-document'
export const URL_ENDPOINT_DOCUMENT = `${BASE_URL}/document`
